import { Injectable } from '@angular/core';
import { ToastMessages } from '@app/constants';
import { ToastTypeEnum } from '@app/enums/toast-type.enum';
import { PragmaticsService } from '@app/services/pragmatics.service';
import { ToastService } from '@app/services/toast.service';
import { ValorationService } from '@app/services/valoration.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';
import { PragmaticInfoActions } from './pragmatic-info.action.types';

@Injectable()
export class PragmaticInfoEffects {

  getPragmaticLogedUser$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(PragmaticInfoActions.loadPragmaticLogedUser),
      mergeMap(() => {
        return this.pragmaticsService.requestPragmaticUserInfobyToken().pipe(
          map((result) =>
            PragmaticInfoActions.loadPragmaticLogedUserSuccessfully({
              pragmaticLogedUser: result.pragmatic_info,
            })
          ),
          catchError((error) => {
            this.toastService.open({
              type: ToastTypeEnum.Danger,
              title: ToastMessages.ServerError,
              description: error,
            })
            return of(PragmaticInfoActions.loadPragmaticLogedUserFailure())
          })
        )
      })
    )
  })

  getPragmaticProfile$ = createEffect(() => {
  return this.actions$.pipe(
    ofType(PragmaticInfoActions.loadPragmaticProfile),

    mergeMap(action => {
      const { pragmaticId, email } = action;

      if (pragmaticId) {
        return this.pragmaticsService.requestPragmaticUserInfoById(pragmaticId).pipe(
          map(result =>
            PragmaticInfoActions.loadPragmaticProfileSuccess({
              pragmaticProfile: result.pragmatic_info
            })
          ),
          catchError(() => of(PragmaticInfoActions.loadPragmaticProfileFailure()))
        );
      }

      if (email) {
        return this.pragmaticsService.requestPragmaticUserInfoByEmail(email).pipe(
          map(result =>
            PragmaticInfoActions.loadPragmaticProfileSuccess({
              pragmaticProfile: result.pragmatic_info
            })
          ),
          catchError(() => of(PragmaticInfoActions.loadPragmaticProfileFailure()))
        );
      }

      return of(PragmaticInfoActions.loadPragmaticProfileFailure());
    })
  );
});


getPragmaticChapterDetails$ = createEffect(() => {
  return this.actions$.pipe(
    ofType(PragmaticInfoActions.loadPragmaticChapterDetails),

    mergeMap((action) => {
      const { email, pragmaticId } = action;

      if (email) {
        return this.valorationService.getPragmaticChapterDetails(email).pipe(
          map((details) =>
            PragmaticInfoActions.loadPragmaticChapterDetailsSuccess({
              pragmaticChapterDetails: details,
            })
          ),
          catchError((error) => {
            console.error('[Valoration][Error Email]', error);
            return of(PragmaticInfoActions.loadPragmaticChapterDetailsFailure());
          })
        );
      }

      if (pragmaticId) {
        return this.valorationService.getPragmaticChapterDetailsById(pragmaticId).pipe(
          map((details) =>
            PragmaticInfoActions.loadPragmaticChapterDetailsSuccess({
              pragmaticChapterDetails: details,
            })
          ),
          catchError((error) => {
            console.error('[Valoration][Error Id]', error);
            return of(PragmaticInfoActions.loadPragmaticChapterDetailsFailure());
          })
        );
      }
      return of(PragmaticInfoActions.loadPragmaticChapterDetailsFailure());
    })
  );
});


  constructor( private actions$: Actions,
    private valorationService: ValorationService,
    private readonly pragmaticsService: PragmaticsService,
    private readonly toastService: ToastService
  ) {

}
}